module.exports = __webpack_public_path__ + "img/svg-home-patient.6e123539.svg";